import {useEffect} from "react";

/**
 * Calls `onEscape` when the Escape key is pressed.
 * Only registers the listener when `enabled` is true.
 */
const useEscapeKey = (onEscape: (() => void) | undefined, enabled: boolean): void => {
    useEffect(() => {
        if (!enabled || !onEscape) return;
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape") onEscape();
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [enabled, onEscape]);
};

export default useEscapeKey;
